import React, { useState } from 'react';
import { Box, Card, CardContent, Grid, CardHeader } from '@mui/material';
import { BsFilePdf } from 'react-icons/bs';
import { CalendarMonth } from '@mui/icons-material';
import Header from '../Header';
import NavbarFooter from './NavbarFooter';
import { getDocumentByFileStoreId } from '@egovernments/digit-ui-libraries/src/utils/fileType';

function UserGuideManual() {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return (
    <div>
      <Header />
      <Box sx={{ width: '100%' }}>
        <Card style={{ maxWidth: "100%", height: 'auto', margin: '20px', boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset' }}>
          <CardHeader title='User Manual' style={{ color: "orange" }}></CardHeader>
          <CardContent>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{ display: 'flex', flexDirection: 'row', margin: '10px' }}>
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec' onClick={() => getDocumentByFileStoreId("171f71f5-efe7-476d-835d-6e673d935f2e", setIsPreviewLoading)}>
                      <BsFilePdf size={80} color='#274472' />
                    <h4>Download</h4>  
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>User Manual for OBPS</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec' onClick={() => getDocumentByFileStoreId("3c0512c1-2aff-419b-aa10-1333a15ea3eb", setIsPreviewLoading)}>
                      <BsFilePdf size={80} color='#274472' />
                    <h4>Download</h4>  
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>User Manual for CLU</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec'>
                  <a href='https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=5087c70b-35b5-40cc-92cc-0ac29d92d51b' target="_blank">
                      <BsFilePdf size={80} color='#274472' />
                    </a>
                    Download
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>Sample Drawing for Residential
                    </h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
              {/* <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec'>
                  <a href='https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=6a5f395e-5db7-4753-8744-fb649289f26f' target="_blank">
                      <BsFilePdf size={80} color='#274472' />
                    </a>
                    Download
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>Sample Drawing for Residential - 2</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid> */}
              {/* <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec'>
                  <a href='https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=d5e11115-bfbd-4687-ab1c-eb1b888d6857' target="_blank">
                      <BsFilePdf size={80} color='#274472' />
                    </a>
                    Download
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>Sample Drawing for Residential - 3</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid> */}
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec'>
                  <a href="https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=37838c78-e33e-41a1-be6f-11ae53f92ad1" target="_blank">
                      <BsFilePdf size={80} color='#274472' />
                    </a>
                    Download
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>Sample Drawing for Commercial</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec' onClick={() => getDocumentByFileStoreId("4aa92862-cae2-4423-b0d8-3eb07549e74f", setIsPreviewLoading)}>
                      <BsFilePdf size={80} color='#274472' />
                      <h4>Download</h4>  
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>User Manual for form26</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec' onClick={() => getDocumentByFileStoreId("3bf23245-1112-46d6-b51b-acdfd0dae3cd", setIsPreviewLoading)}>
                    <BsFilePdf size={80} color='#274472' />
                    <h4>Download</h4>  
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>User Manual for form11</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid xs={4} >
                <div className='noti-sec'>
                  <div className='pdf-sec' onClick={() => getDocumentByFileStoreId("9e1a9c1e-b22e-4887-9564-59605064e4f6", setIsPreviewLoading)}>
                    <BsFilePdf size={80} color='#274472' />
                    <h4>Download</h4>  
                  </div>
                  <div className='data-sec'>
                    <h5 style={{ fontSize: "18px", fontWeight: "500", fontFamily: "Open Sans", lineHeight: "22px" }}>User Manual for Mobile Tower Application</h5>
                    <span style={{ color: "#9e9e9e", display: "inline" }}>
                      <CalendarMonth style={{ verticalAlign: "bottom" }} />
                      <span style={{ verticalAlign: "top" }}>20-3-2024</span>
                    </span>
                  </div>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <NavbarFooter />
    </div>
  );
}

export default UserGuideManual;
